import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Signup from '@/components/Signup'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard/Dashboard'
import DoubtView from '@/components/Dashboard/DoubtView'
import DashboardOverview from '@/components/Dashboard/Overview'
import DashboardAddDoubt from '@/components/Dashboard/AddDoubt'
import Solutions from '@/components/Dashboard/Solutions'
import History from '@/components/Dashboard/History'
import Packages from '@/components/Dashboard/Packages'
import PackagesHistory from '@/components/Dashboard/PackagesHistory'
import PackageView from '@/components/Dashboard/PackageView'
import ForgotPassword from '@/components/ForgotPassword'
import StudyMaterial from '@/components/Dashboard/StudyMaterial'
import StudyMaterialTag from '@/components/Dashboard/StudyMaterialTag'
import Notepad from '@/components/Dashboard/Notepad'
import Utilities from '@/components/Dashboard/Utilities'
import Calculator from '@/components/Dashboard/Calculator'
import UnitConvertor from '@/components/Dashboard/UnitConvertor'
import Support from '@/components/Dashboard/Support'
import Account from '@/components/Dashboard/Account'
import CareerCounselling from '@/components/Dashboard/CareerCounselling'
import Share from '@/components/Dashboard/Share'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/forgotpassword',
      name: 'Forgot Password',
      component: ForgotPassword
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      children: [
        {
          name:'Account',
          path:'account',
          component: Account
        },
        {
          name:'CareerCounselling',
          path:'career-counselling',
          component: CareerCounselling
        },
        {
          name: 'StudyMaterial',
          path: 'study-material',
          component: StudyMaterial
        },
        {
          name: 'StudyMaterialTag',
          path: 'study-material/:tag',
          component: StudyMaterialTag
        },
        {
          path: '',
          component: DashboardOverview
        }, {
          path: 'add-doubt',
          component: DashboardAddDoubt
        }, {
          path: 'solutions',
          component: Solutions
        }, {
          path: 'history',
          component: History
        }, {
          path: 'packages',
          component: Packages
        },
        {
          path: 'packages/:id',
          component: PackageView
        },
        {
          path: 'packages-history',
          component: PackagesHistory
        }, {
          path: 'doubts/:id',
          component: DoubtView
        },
        {
          path: 'notepad',
          component: Notepad
        },
        {
          path: 'utilities',
          component: Utilities
        },
        {
          path: 'calculator',
          component: Calculator
        },
        {
          path: 'unit-convertor',
          component: UnitConvertor
        },
        {
          path: 'support',
          component: Support
        },
        {
          path:'share',
          component: Share
        }
      ]
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js